
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import End from './End'
import selectHasGigEnded from '../../dataStore/selectors/selectHasGigEnded'
import { State } from '../../dataStore/reducers/reducerType'
import { EndProps } from './types'
import { tearDownGig } from '../../dataStore/actions/room/room'

const mapStateToProps = (state: State): Omit<EndProps, 'match' | 'history' | 'tearDownGig'> => ({
  hasGigEnded: selectHasGigEnded(state),
  isEndRequested: state.ui.isEndRequested,
  status: state.ui.status
})

const mapDispatchToProps = (dispatch): Pick<EndProps, 'tearDownGig'> => ({
  tearDownGig: () => dispatch(tearDownGig())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(End))
